exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mint__modal--inner{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    grid-gap: 12px;\n    gap: 12px;\n}\n\n.treasure__mint--button{\n    padding: 1.2rem 2rem;\n    min-width: 200px;\n    background: #E5E8EB0A;\n    border-radius: 4px;\n    color: #E5E8EBCC;\n}\n\n.treasure__mint--button:hover{\n    background: #E5E8EB0F;\n}", ""]);

// exports
